import { render, staticRenderFns } from "./sidepanel-iframe.vue?vue&type=template&id=3d733982"
import script from "./sidepanel-iframe.vue?vue&type=script&lang=js"
export * from "./sidepanel-iframe.vue?vue&type=script&lang=js"
import style0 from "./sidepanel-iframe.vue?vue&type=style&index=0&id=3d733982&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports